import {useFetch, useRequestHeaders} from "nuxt/app";
import {useAPIBaseUrl} from "@composables/useAPIBaseUrl";
import IPageData from "@shared/interfaces/dtos/IPageData";
import { Ref, ComputedRef, computed } from "vue";
import { SearchType } from "@domain/enums/SearchType";
import IPersonalizedProgrammeCard from "@shared/interfaces/dtos/IPersonalizedProgrammeCard";
import IPersonalizedOrganisationCard from "@shared/interfaces/dtos/IPersonalizedOrganisationCard";

const getAPIPath = (searchType: Ref<SearchType>): ComputedRef<string> => computed(() => {
	switch(searchType.value){
	case SearchType.PROGRAMME_SEARCH:
		return "/api/search/programmes";
	case SearchType.UNIVERSITY_SEARCH:
		return "/api/search/organisations";
	case SearchType.SCHOLARSHIP_SEARCH:
		return "/api/search/scholarships";
	default:
		throw new Error('Invalid search type');
	}
});


// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useSearchAPI = (filters: Ref<any>, sortBy: Ref<any>, searchType: Ref<SearchType>, offset: Ref<number>) => {
	const headers = useRequestHeaders(['cookie', 'user-agent', 'x-forwarded-for', 'host']);
	return useFetch<IPageData<IPersonalizedProgrammeCard | IPersonalizedOrganisationCard> | null>(
		getAPIPath(searchType),
		{
			server: true,
			immediate: false,
			ignoreResponseError: true,
			headers,
			method: "POST",
			body: {
				filters,
				sortBy,
				resultOffset: offset,
				portalMap: import.meta.client ? window.PortalMap : undefined
			},
			credentials: 'include',
			watch: false,
			$fetch: $fetch.create({baseURL: useAPIBaseUrl()})
		}
	);
}
